import { atom, useAtom, useAtomValue } from "jotai";

import { ComboPricesRowType, type PricesTableEntry } from "#/types/combo";

export const defaultLimitNetPrices: Partial<
  Record<ComboPricesRowType, string>
> = {
  [ComboPricesRowType.Summary]: "",
  [ComboPricesRowType.PerpsLeg]: "",
};

export const comboPricesAtom = atom<PricesTableEntry[]>([]);
export const limitNetPricesAtom = atom<
  Partial<Record<ComboPricesRowType, string>>
>(defaultLimitNetPrices);

export const hasEnoughLiquidityAtom = atom((get) => {
  const comboPrices = get(comboPricesAtom);

  const legs = comboPrices.filter((entry) =>
    [ComboPricesRowType.OptionsLeg, ComboPricesRowType.PerpsLeg].includes(
      entry.rowType,
    ),
  );

  return legs.length > 0 && legs.every((leg) => leg.hasEnoughLiquidity);
});

export const areLimitNetPricesFilledAtom = atom((get) => {
  const limitNetPrices = get(limitNetPricesAtom);
  const comboPrices = get(comboPricesAtom);
  const hasPerpsLeg = comboPrices.some(
    (entry) => entry.rowType === ComboPricesRowType.PerpsLeg,
  );

  return hasPerpsLeg
    ? Object.values(limitNetPrices).every((price) => price !== "")
    : limitNetPrices[ComboPricesRowType.Summary] !== "";
});

export const useComboPrices = () => {
  const [comboPrices, setComboPrices] = useAtom(comboPricesAtom);
  const [limitNetPrices, setLimitNetPrices] = useAtom(limitNetPricesAtom);
  const hasEnoughLiquidity = useAtomValue(hasEnoughLiquidityAtom);
  const areLimitNetPricesFilled = useAtomValue(areLimitNetPricesFilledAtom);

  return {
    comboPrices,
    hasEnoughLiquidity,
    limitNetPrices,
    setComboPrices,
    setLimitNetPrices,
    areLimitNetPricesFilled,
  };
};
